
import { defineComponent } from 'vue';
import 'normalize.css';
import '@/assets/css/app.css';

export default defineComponent({});
